export const VatQueryKeys = {
    all: ['vat'] as const,
    /**
     * `locale` is part of the key because it is part of the request: account
     * names arrive already resolved server-side, so switching the app language
     * has to refetch rather than re-resolve a map the client holds.
     */
    report: (fromDate: string, toDate: string, locale: string) =>
        [...VatQueryKeys.all, 'report', fromDate, toDate, locale] as const,
};
